import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Alert,
  Typography,
} from '@mui/material';
import TokenInstructions from '../../../components/TokenInstructions';

const ConfluenceAuthModal = ({
  open,
  onClose,
  onSubmit,
  isAuthenticated,
  savedToken,
  onLogout,
}) => {
  const [tokenInput, setTokenInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    const trimmed = tokenInput.trim();
    if (!trimmed) {
      setError('Токен обязателен для заполнения');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await onSubmit(trimmed);
      handleClose();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Произошла ошибка при авторизации');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setTokenInput('');
      setError(null);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Токен Confluence</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          {error && <Alert severity="error">{error}</Alert>}

          {isAuthenticated ? (
            <Typography variant="body2" color="text.secondary">
              Токен установлен. Последние 4 символа: ***{savedToken?.slice(-4) || ''}
            </Typography>
          ) : (
            <>
              <Typography variant="body2" color="text.secondary">
                Введите персональный токен доступа Confluence
              </Typography>
              <TextField
                label="Confluence Token"
                type="password"
                variant="outlined"
                fullWidth
                value={tokenInput}
                onChange={(e) => setTokenInput(e.target.value)}
                placeholder="ATATT3xFfGF0xxxxxxxxxxxxxxxxxxxxxxxx"
                disabled={loading}
                helperText="Введите ваш персональный токен доступа Confluence"
              />

              <TokenInstructions
                steps={[
                  'Войдите в Confluence.',
                  'Откройте меню профиля и перейдите в раздел «Личные маркеры доступа» (Personal Access Tokens).',
                  'Нажмите «Создать маркер» (Create token) и задайте название, например «Контекст».',
                  'Скопируйте сгенерированный маркер — он показывается только один раз.',
                  'Вставьте маркер в поле «Confluence Token».',
                ]}
              />
            </>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Закрыть
        </Button>
        {isAuthenticated && onLogout && (
          <Button onClick={onLogout} color="error" disabled={loading}>
            Выйти
          </Button>
        )}
        {!isAuthenticated && (
          <Button
            onClick={handleSubmit}
            variant="contained"
            disabled={!tokenInput.trim() || loading}
          >
            {loading ? 'Сохранение...' : 'Установить'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ConfluenceAuthModal;
